import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ActressList from './components/ActressList';
import ActressDetailEnhanced from './components/ActressDetailEnhanced';
import VideoList from './components/VideoList';
import VideoDetailNew from './components/VideoDetailNew';
import UnifiedSearch from './components/UnifiedSearch';
import MockDataToggle from './components/MockDataToggle';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <div className="flex-shrink-0 flex items-center">
                  <Link to="/" className="text-xl font-bold text-blue-600">
                    Project Bacchus
                  </Link>
                </div>
                <nav className="ml-6 flex space-x-8">
                  <Link
                    to="/actresses"
                    className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  >
                    女優一覧
                  </Link>
                  <Link
                    to="/videos"
                    className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  >
                    作品一覧
                  </Link>
                  <Link
                    to="/search"
                    className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  >
                    検索
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route path="/" element={<VideoList />} />
            <Route path="/actresses" element={<ActressList />} />
            <Route path="/actresses/:id" element={<ActressDetailEnhanced />} />
            
            <Route path="/videos" element={<VideoList />} />
            <Route path="/videos/:id" element={<VideoDetailNew />} />
            <Route path="/search" element={<UnifiedSearch />} />
          </Routes>
        </main>

        <footer className="bg-white border-t border-gray-200 py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-center text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} Project Bacchus. All rights reserved.
            </p>
          </div>
        </footer>
        
        <MockDataToggle />
      </div>
    </Router>
  );
}

export default App;